/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Permissions_DescriptionInputs */



/**
* | output |
* | --- |
* | "Select groups that can access this folder:" |
*
* @param {Explorer_Info_Permissions_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_permissions_description = /** @type {((inputs?: Explorer_Info_Permissions_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Permissions_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Selectionnez les groupes pouvant acceder a ce dossier :")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie die Gruppen aus, die auf diesen Ordner zugreifen können:")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona i gruppi che possono accedere a questa cartella:")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите группы, которым разрешен доступ к этой папке:")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccionar grupos que pueden acceder a esta carpeta:")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择可以访问此文件夹的组：")
	if (locale === "ja") return /** @type {LocalizedString} */ ("このフォルダにアクセスできるグループを選択してください:")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उन समूहों का चयन करें जो इस फ़ोल्डर तक पहुंच सकते हैं:")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione os grupos que podem acessar esta pasta:")
	return /** @type {LocalizedString} */ ("Select groups that can access this folder:")
});